import { Box, Link as MuiLink, styled } from "@mui/material";
import { ReactNode, useState } from "react";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

interface ExpandableSectionProps {
    toggleText: string;
    children: ReactNode;
}

const Link = styled<any>(MuiLink)(() => ({
    textDecoration: 'none'
}));

const IconBox = styled(Box)(({theme}) => ({
    color: theme.palette.primary.main
}));

export default function ExpandableSection({ toggleText, children, ...restProps }: ExpandableSectionProps) {
  const [open, setOpen] = useState(false);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setOpen((previousOpen) => !previousOpen);
  };

  const id = open ? 'transition-popper' : undefined;

  return (
    <div {...restProps}>
      <IconBox sx={{ display: 'inline-block', verticalAlign: 'sub' }}>
        {open ? <KeyboardArrowDownIcon fontSize="small" /> : <KeyboardArrowRightIcon fontSize="small" />}
      </IconBox>  
      <Link aria-describedby={id} component="button" variant="body1" onClick={handleClick}>
        {toggleText}
      </Link>
      <Box id={id} sx={{ display: open ? 'bllock': 'none' }} >
        {children}
      </Box>
    </div>
  );
}